import styled from 'styled-components';

export const SectionsScrollContainer = styled.div`
    // text-shadow: black 0px 0px 5px;
    // background-color: black;
    width: 100%;
    height: auto;
    margin: 10px 0 5px 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .sections-scroll-box {
        // background-color: yellow; 
        width: 98%;
        height: 95%;
        // display: flex;
        overflow: hidden;

        .sections-scroll {
            width: auto;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: ${window.screen.width <= 1300 ? '' : 'center'};
            overflow-y: hidden;
            overflow-x: ${window.screen.width <= 1300 ? 'auto' : 'hidden'}; 
        }
    }

    
`;